<template>
    <form method="POST" action="/statistics/packs/excel">
        <input type="hidden" name="_token" :value="csrf_token">

        <div class="row">
            <div class="col-md-9">
                <date-range-picker :translations="translations" @update-date="updateDate"/>

                <div class="col-md-12">
                    <!-- Tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="active" role="presentation">
                            <a href="#brands" role="tab" data-toggle="tab">
                                {{ translations.brands }}
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#statuses" role="tab" data-toggle="tab">
                                {{ translations.statuses }}
                            </a>
                        </li>
                    </ul>

                    <!-- Tabs content here -->
                    <div class="tab-content">
                        <div id="brands" class="tab-pane active">
                            <brands-list
                                :brands="brands"
                                :translations="translations"
                                @update-brands="updateBrands"
                            />
                        </div>
                        <div id="statuses" class="tab-pane">
                            <statuses-list
                                :statuses="statuses"
                                :translations="translations"
                                @update-statuses="updateStatuses"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-3" style="margin-top: 24px">
                <div class="form-group">
                    <div class="btn btn-primary form-control" @click="load()" >
                        <i v-show="is_loading" class="fa fa-spinner fa-spin" style="font-size:24px"/>
                        <span v-show="!is_loading">
                            <i class="fa fa-download"/>
                            {{ translations.load_button }}
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success form-control">
                        <i class="fa fa-file-excel-o"></i>
                        {{ translations.download_excel }}
                    </button>
                </div>
                <div class="form-group">
                    <label>
                        <input type="checkbox"
                               name="without_discontinued_products"
                               v-model="without_discontinued_products" />
                        {{ translations.without_discontinued_products }}
                    </label>
                    <label>
                        <input type="checkbox"
                               name="only_sold_packs"
                               v-model="only_sold_packs" />
                        {{ translations.only_sold_packs }}
                    </label>
                </div>
            </div>
        </div>

        <!-- Result table here -->
        <table-paginated
            :columns="columns"
            :paginator="paginator"
            :columns_info="columns_info"
            :translations="translations"
            @update-page="updatePage"
        />

    </form>
</template>

<script>
export default {
    props: ['statuses', 'brands', 'translations'],
    data() {
        return {
            columns: [],
            brandIds: [],
            statusIds: [],
            columns_info: {},
            date_start: '',
            date_finish: '',
            paginator: null,
            is_loading: false,
            without_discontinued_products: false,
            only_sold_packs: false
        };
    },
    computed: {
        csrf_token() {
            return document.querySelector('#token').getAttribute('content');
        }
    },
    methods: {
        updateDate(object) {
            this.date_start = object.date_start;
            this.date_finish = object.date_finish;
        },
        updateBrands(brandIds) {
            this.brandIds = brandIds;
        },
        updateStatuses(statusIds) {
            this.statusIds = statusIds;
        },
        updatePage(page) {
            this.load(page);
        },
        load(pageNumber = 1) {
            if (!this.isDataValid()) {
                alert(this.translations.not_filled_fields); return;
            }

            this.is_loading = true;

            this.$http.post('/statistics/packs/load', {
                page: pageNumber,
                brands: this.brandIds,
                statuses: this.statusIds,
                date_start: this.date_start,
                date_finish: this.date_finish,
                without_discontinued_products: this.without_discontinued_products,
                only_sold_packs: this.only_sold_packs
            }).then((response) => {
                this.is_loading = false;

                this.columns = response.data.columns;
                this.paginator = response.data.paginator;
                this.columns_info = response.data.columns_info;
            }).catch((response) => {
                this.is_loading = false;
                alert(response.data.message);
            });
        },
        isDataValid() {
            return this.brandIds.length &&
                   this.statusIds.length &&
                   this.date_start.length &&
                   this.date_finish.length;
        }
    },
};
</script>
